import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { reduxForm, change } from 'redux-form';
import { Button, Row, Col, Form, FormGroup, Label } from 'reactstrap';

import './FormRenderer.css';

let FormRenderer = props => {
    const dispatch = useDispatch();

    const { handleSubmit, pristine, submitting, resources } = props;
    const { formLayout, isLoading, className }              = props;
    const { defaultValues, preFields, postFields }          = props;

    const { t, i18n } = useTranslation();
    const { result }  = useSelector(state => state.formLayouts);
    const { user }    = useSelector(state => state.auth);

    const context = React.useMemo(() => ({
        lang: i18n.language,
        resources
    }), [i18n.language, resources]);

    useEffect(() => {
        if (user) {
            const updatable = [
                'firstname', 'lastname', 'email', 'address',
                'avs', 'bank', 'bic', 'birthday', 'city',
                'country', 'email', 'fax', 'firstname',
                'fix_phone', 'gender', 'iban', 'lastname',
                'mobile_phone', 'pro_phone', 'zip'
            ];
            formLayout.fields
                .filter(f => updatable.includes(f.name))
                .forEach(field => {
                    dispatch(change('formRenderer', field.id, user[field.name]));
                });
        }
    }, [user]);

    useEffect(() => {
        if (defaultValues) {
            const updatable = Object.keys(defaultValues);
            formLayout.fields
                .filter(f => updatable.includes(f.name))
                .forEach(field => {
                    dispatch(change('formRenderer', field.id, defaultValues[field.name]));
                });
        }
    }, [defaultValues]);

    return (
        <div className={`FormRenderer ${className || ''}`}>
            <h3 className="mb-3">
                { formLayout.name[i18n.language] }
            </h3>
            <Form onSubmit={handleSubmit}>
                <Row>
                    { preFields }
                    {formLayout.fields.sort((a, b) => a.position - b.position).map(field => (
                        <Col key={field.id} sm={12} md={Math.round(field.width * 12)} >
                            <FormGroup row>
                                <Col sm={12} className="text-left font-weight-bold">
                                    { field.getLabel(context) }
                                </Col>
                                <Col sm={12}>
                                    { field.getInput(context) }
                                </Col>
                            </FormGroup>
                        </Col>
                    ))}
                    { postFields }
                </Row>
                <FormGroup row className="mt-3">
                    <Col>
                        <Button type="submit" color="info">
                            <i className={`fa ${isLoading ? 'fa-spinner fa-spin' : 'fa-save'}`}></i>&nbsp;
                            { t('common.save') }
                        </Button>
                    </Col>
                </FormGroup>
            </Form>
        </div>
    );
}

FormRenderer = reduxForm({
    form: 'formRenderer',
    enableReinitialize: true
})(FormRenderer);

FormRenderer = connect(
    state => ({
        initialValues: {}
    }), {}
)(FormRenderer)

export default FormRenderer;
